/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ScreenerLeadMatrixCareStatus = {
    NoStatus: 'No Status',
    PushedToMatrixCare: 'Pushed to MatrixCare'
} as const;
export type ScreenerLeadMatrixCareStatus = typeof ScreenerLeadMatrixCareStatus[keyof typeof ScreenerLeadMatrixCareStatus];


export function ScreenerLeadMatrixCareStatusFromJSON(json: any): ScreenerLeadMatrixCareStatus {
    return ScreenerLeadMatrixCareStatusFromJSONTyped(json, false);
}

export function ScreenerLeadMatrixCareStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScreenerLeadMatrixCareStatus {
    return json as ScreenerLeadMatrixCareStatus;
}

export function ScreenerLeadMatrixCareStatusToJSON(value?: ScreenerLeadMatrixCareStatus | null): any {
    return value as any;
}

